module.exports = __webpack_public_path__ + "static/media/signin-default.6d5c17ce.jpg";